/* eslint-disable consistent-return */
export default {
  // TOP_ABOVE_MENU_CTR
  LOGO_CLICK: "logo_click",
  MYBAG_CLICK: "mybag_click",
  LOGIN_CLICK: "login_click",
  STORE_LOCATOR_CLICK: "storelocator_click",
  MENU_OPEN: "open",
  MENU_CLOSE: "close",

  // LOGIN
  LOGIN_CANCEL: "cancel",
  LOGIN_FILLED: "filled_attempt",
  LOGIN_SUCCESS: "success",
  LOGIN_ERROR: "login_error",
  FORGOT_PASSWORD_CLICK: "forgot_password_click",
  REGISTER_CLICK: "register_click",
  REGISTER_ATTEMPT: "final_register_attempt",
  REGISTER_SUCCESS: "final_register_success",
  REGISTER_ERROR: "register_login_error",
  MISSED_FIELDS: "enter_phone_screen",
  MISSED_FIELDS_ERROR: "no_phone_email_error",
  FACEBOOK_LOGIN: "fb_click",
  GMAIL_LOGIN: "google_click",
  FORGOT_PASSWORD_ATTEMPT: "forgot_password_attempt",
  FORGOT_PASSWORD_SUCCESS: "forgot_password_success",
  LOGOUT: "logout",
  SOCIAL_LOGIN_PHONE_NUDGE: "social_login_phone_nudge",

  // minipdp
  COLOR_CHANGE: "color_change",
  SIZE_CHANGE: "size_change",
  ADD_TO_BAG_ISSUE: "add_to_bag_size_issue",
  ADD_TO_BAG_SUCCESS: "add_to_bag_success",
  MINI_PDP_CLOSE: "cancel",
  PRODUCT_CAROUSEL_VIEW_ALL: "view_all_click",
  PRODUCT_CAROUSEL: "click",
  // SEARCH
  SEARCH_CLICK: "search_click",
  SEARCH_CLOSE: "close_button_click",
  REPEAT_SEARCH: "repeat_search",
  QUERY_ENTER: "query_enter",
  BLANK_QUERY_ERROR: "blank_query_error",
  FIND_NOW_CLICK: "find_now_click",
  FILTER_BRAND_APPLIED: "brand_applied",
  FILTER_COLOR_APPLIED: "color_applied",
  getFilterType: type => {
    if (type === "Occasion") return "occasion_applied";
    else if (type === "Price") return "budget_applied";
  },

  // FILTER
  FILTER_CATEGORY: "filter_category",

  // AUTHINTERCEPTOR
  REFRESH_TOKEN_FAIL: "blackboltRefreshTokenFailed",
  getApiFailUrl: (method, url) => `${method}__${url}`,

  // FOOTER
  SUBSCRIBE_USER: "email_subscribe",
  BACK_TO_TOP: "back_to_top_click",
  WHO_WE_ARE: "who_we_are_click",
  CUSTOMER_CARE_CLICK: "customer_care_click",
  CONTACT_US_CLICK: "contact_us_click",
  FB_CLICK: "fb_click",
  INSTA_CLICK: "insta_click",
  POLICY_CLICK: "privacy_policy_click",
  T_N_C_CLICK: "t_and_c_click",

  // MINI BAG
  MINIBAG_MYBAG_CLICK: "mybag_click",
  MINIBAG_CHECKOUT_CLICK: "checkout_click",
  MINIBAG_PRODUCT_REMOVE: "product_remove",

  // LISTING
  LANDED: "landed",
  SORT_HIGH_TO_LOW: "sort_price_high_to_low",
  SORT_LOW_TO_HIGH: "sort_price_low_to_high",
  SORT_NEWEST: "sort_newest",
  SORT_POPULARITY: "sort_popularity",
  SORT_RELEVANCE: "sort_relevance",
  GRID_VIEW: "grid_grid",
  LIST_VIEW: "grid_single",
  STORE_PINCODE: "store_pincode",
  DELIVERY_PINCODE: "delivery_pincode",
  getSortType: sort => `sort_${sort}`,
  getShopNNNOW: (page, imageSize, device, index) =>
    `shop_page_${page}_size_${imageSize}_${device}_index_${index}`,
  getFavClick: (page, imageSize, device, index) =>
    `fav_page_${page}_size_${imageSize}_${device}_index_${index}`,
  getProductClick: (page, imageSize, device, index) =>
    `product_click_page_${page}_size_${imageSize}_${device}_index_${index}`,
  getProductImpression: (page, imageSize, device, index) =>
    `impr_page_${page}_size_${imageSize}_${device}_index_${index}`,
  getListPageNo: pageNo => `page_${pageNo}`,
  getMasterTemplateActions: inputArray => inputArray.join("_"),
  // PDP
  CHECKOUT_CLICK: "checkout_click",
  SHARE_HOVER: "share_hover",
  SHARE_SELECTED: "share_selected",
  SHARE_CLICK: "share_click",
  SHARE_CLOSE: "share_close",
  SHORTLIST_PRE_LOGIN: "short_list_pre_login",
  SHORLIST_SUCCESS: "short_list_success",
  SHORLIST_REMOVED: "short_list_removed",
  ADD_TO_BAG_SIZE_PROMT: "add_to_bag_size_prompt",
  ADD_TO_BAG_SIZE_PROMPT_SELECTED: "size_prompt_selected",
  ADD_TO_BAG_SIZE_PROMPT_CLOSE: "size_prompt_close",
  COMPLETE_LOAD: "complete_load",
  FIT_GUIDE_CLICK: "fit_guide_click",
  OTHER_ELIGIBLE_PRODUCTS_CLICK: "other_eligible_products_click",
  PINCODE_CHECKED_SIZE_ISSUE: "pincode_checked_size_issue",
  IMAGE_CHANGE: "image_change",
  FINER_DETAILS_TAB: "finer_details_tab",
  OFFER_CODE_CLICK: "offer_code_click",
  ABOUT_TAB: "about_tab",
  RETURNS_TAB: "returns_tab",
  SHORTLIST_PRELOGIN: "short_list_pre_login",
  PINCODE_CHECKED: "pincode_checked",
  PINCODE_ENTERED: "pincode_entered",
  PINCODE_ERROR: "pincode_error",
  STORES_NEARBY_CLICK: "stores_nearby_click",
  ZOOM_CLICK: "zoom_click",
  getTabClicked: active => `${active}_tab`,
  secondaryProductsClick: (index, type) =>
    `${type.replace(" ", "_").toLowerCase()}_${index}`,
  getFavClickFromPdp: (page, imageSize, device, index, origin = "") =>
    `${origin
      .replace(" ", "_")
      .toLowerCase()}_fav_page_${page}_size_${imageSize}_${device}_index_${index}`,
  getShopNNNOWFromPdp: (page, imageSize, device, index, origin = "") =>
    `${origin
      .replace(" ", "_")
      .toLowerCase()}_shop_page_${page}_size_${imageSize}_${device}_index_${index}`,
  BRAND_SELECTION: "brand_selection",
  PINCODE_FILL: "pincode_fill",
  FIND_NOW_CLICK_SL: "find_now_click",
  FIND_NOW_ERROR: "find_now_error",
  STORE_UNIT_CLICK: "store_unit_click",
  MORE_INFO_CLICK: "more_info_click",
  GET_DIRECTION_CLICK: "get_direction_click",
  SHOP_STORE_CLICK: "shop_store_click",
  MAP_STORE_CLICK: "map_store_click",
  ZERO_STORE: "0_store",
  MASTER_TEMPLATE_PAGES: {
    LEFT_NAV_DESKTOP: "left_nav_desktop_click",
    LEFT_NAV_MOBILE: "left_nav_mobile",
    TOP_BAR: "top_bar",
    TOP_BANNER: "banner_click",
    PRODUCT_CAROUSEL: "product_carousel",
    QUICK_LINKS: "quicklinks_click",
    BANNER_CAROUSEL: "banner_carousel_click",
    STORY: "story_click",
    SECTION_CAROUSEL: "story_click",
    VIDEO: "video_play",
  },
};



// WEBPACK FOOTER //
// ./src/analytics/eventFactory/actions.js